import request from '../../utils/request'

// 获取客服列表信息
export const getCustomerList = (data) => {
  return request({
    url: `/api/admin/customer-service-qr/list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&keyword=${data.keyword}&status=${data.status}&qrType=${data.qrType}`,
    method: 'get'
  })
}

// 创建客服
export const addCustomer = (data) => {
  return request({
    url: '/api/admin/customer-service-qr/create',
    method: 'post',
    data
  })
}

// 上传图片
export const uploadImg = (file) => {
  // 1. 创建 FormData 对象（必须，用于封装文件）
  const formData = new FormData();
  // 2. 把文件追加到 FormData 中（参数名要和接口文档的「file」一致）
  formData.append('file', file);

  return request({
    url: '/api/admin/files/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 更新客服信息
export const updateCustomer = (data) => {
  return request({
    url: '/api/admin/customer-service-qr/update',
    method: 'post',
    data
  })
}

// 删除客服
export const delCustomer = (qrId) => {
  return request({
    url: `/api/admin/customer-service-qr/delete/${qrId}`,
    method: 'post',
  })
}
 